import React, { useEffect, useState } from "react";

import Steps from "../Steps/Steps";
import { Link } from "react-router-dom";
import axios from "axios";
import { useCookies } from "react-cookie";
import * as Constants from '../../../constants/urls';
import Breadcrumb from "../../Breadcrumb/Breadcrumb";

const AnbargardaniList = (props) => {
     const [cookies, setCookie, removeCookie] = useCookies();

     function getAnbargardani() {
          const url = Constants.apiUrl + "/api/ag/getAnbargardaniList";
          axios.get(url, {
               headers: {
                    'Authorization': 'Bearer ' + cookies.user_server_token,
               }
          }).then((r) => {
          }).catch((e) => {
               if (e.response.status == 403) {
                    window.location = "403";
               }

          });
     }

     useEffect(() => {
          getAnbargardani();
     }, [])

     return (
          <>
               <Breadcrumb title={"انبارگردانی"} />

               <div style={{ display: "flex", alignItems: "center", background: "url('" + Constants.watermarkUrl + "')", backgroundRepeat: "no-repeat", minHeight: "90vh", backgroundPosition: "center", backgroundColor: "#fff" }}>
                    <div className="container" >
                         <Link to={"/admin/ag1"}>
                              <div className={[' btn btn-block btn-danger py-4 my-2 text-white border border-white'].join(' ')} style={{ direction: 'rtl', opacity: "0.9" }}>
                                   <strong className={['m-0 text-center', 'p-0'].join(' ')}>  انبارگردانی مرحله اول </strong>
                              </div>
                         </Link>
                         <Link to={"/admin/ag2"}>
                              <div className={[' btn btn-block btn-danger py-4 my-2 text-white border border-white'].join(' ')} style={{ direction: 'rtl', opacity: "0.9" }}>
                                   <strong className={['m-0 text-center', 'p-0'].join(' ')}>  انبارگردانی مرحله دوم </strong>
                              </div>
                         </Link>
                         <Link to={"/admin/ag3"}>
                              <div className={[' btn btn-block btn-danger py-4 my-2 text-white border border-white'].join(' ')} style={{ direction: 'rtl', opacity: "0.9" }}>
                                   <strong className={['m-0 text-center', 'p-0'].join(' ')}>  انبارگردانی مرحله سوم </strong>
                              </div>
                         </Link>
                         <Link to={"/admin/ag/location_log"}>
                              <div className={[' btn btn-block btn-danger py-4 my-2 text-white border border-white'].join(' ')} style={{ direction: 'rtl', opacity: "0.9" }}>
                                   <strong className={['m-0 text-center', 'p-0'].join(' ')}> لاگ لوکیشن ها </strong>
                              </div>
                         </Link>

                         <Link to={"/admin/ag/Product_log"}>
                              <div className={[' btn btn-block btn-danger py-4 my-2 text-white border border-white'].join(' ')} style={{ direction: 'rtl', opacity: "0.9" }}>
                                   <strong className={['m-0 text-center', 'p-0'].join(' ')}> لاگ محصولات ها </strong>
                              </div>
                         </Link>
                         <a href={Constants.panelUrl + "/anbargardani/not-exist-pack"}>
                              <div className={[' btn btn-block btn-danger py-4 my-2 text-white border border-white'].join(' ')} style={{ direction: 'rtl', opacity: "0.9" }}>
                                   <strong className={['m-0 text-center', 'p-0'].join(' ')}> لاگ بسته های انبارگردانی نشده </strong>
                              </div>
                         </a>
                         <Link to={"/admin/"}>
                              <div className={[' btn btn-block btn-danger py-4 my-2 text-white border border-white'].join(' ')} style={{ direction: 'rtl', opacity: "0.9" }}>
                                   <strong className={['m-0 text-center', 'p-0'].join(' ')}>  خروج </strong>
                              </div>
                         </Link>
                    </div>
               </div>
          </>
     )
}
export default AnbargardaniList;
